import React, { useState } from 'react'

import { Candidate } from '../../types'
import { ApplicationContext } from './ApplicationContext'

export const ApplicationProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<Candidate>()
  const values = {user, setUser}

  return <ApplicationContext.Provider value={values}>{children}</ApplicationContext.Provider>
}
